import IframeResizer from '@rio-cloud/iframe-resizer';
import { RioNotifications } from '@rio-cloud/rio-notifications-component';
import { OrderChat } from '@rio-cloud/rio-order-chat-component';
import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import { DefaultUserMenu } from '@rio-cloud/rio-user-menu-component';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';

import { config } from '../../config';
import { getUserProfile } from '../../configuration/login/loginSlice';
import { useAppSelector } from '../../configuration/setup/hooks';
import { getIdToken } from '../../configuration/tokenHandling/tokenSlice';
import useIsSupportAdministrationRoute from '../../hooks/useIsSupportAdministrationRoute';
import { ADMINISTRATION_ROUTE, SUPPORT_ADMINISTRATION_ROUTE } from '../../routes/Router';
import { RENTAL_ONBOARDING_STEP } from '../onboarding/onboardingUtils';
import { OnboardingPanel } from '../onboarding/RentalOnboardingTour';
import serviceInfo from '../serviceInfo/ServiceInfo';

const AppHeader = () => {
    const isSupportAdminRoute = useIsSupportAdministrationRoute();

    const idToken = useAppSelector(getIdToken);
    const tenant = useAppSelector(getUserProfile)?.tenant || 'unknown';
    const postLogoutRedirectUri = config.login.postLogoutRedirectUri;

    const navItems = isSupportAdminRoute
        ? [
              {
                  key: 'rental',
                  route: (
                      <NavLink to={SUPPORT_ADMINISTRATION_ROUTE}>
                          <OnboardingPanel step={RENTAL_ONBOARDING_STEP.rentalTab}>
                              <FormattedMessage id={'intl-msg:navigation-bar.sublink.rental'} />
                          </OnboardingPanel>
                      </NavLink>
                  ),
              },
          ]
        : [
              {
                  key: 'rental',
                  route: (
                      <NavLink to={ADMINISTRATION_ROUTE}>
                          <OnboardingPanel step={RENTAL_ONBOARDING_STEP.rentalTab}>
                              <FormattedMessage id={'intl-msg:navigation-bar.sublink.rental'} />
                          </OnboardingPanel>
                      </NavLink>
                  ),
              },
              {
                  key: 'partners',
                  route: (
                      <NavLink to='/partners'>
                          <OnboardingPanel step={RENTAL_ONBOARDING_STEP.partnersTab}>
                              <FormattedMessage id={'intl-msg:navigation-bar.sublink.partners'} />
                          </OnboardingPanel>
                      </NavLink>
                  ),
              },
          ];

    const environment = import.meta.env.PROD ? 'production' : 'local';

    const userMenuItem = (
        <DefaultUserMenu
            environment={environment}
            postLogout={
                idToken && postLogoutRedirectUri
                    ? { redirectUri: postLogoutRedirectUri, idTokenHint: idToken }
                    : undefined
            }
            disableCookieModal
        />
    );
    const menuUrl = config.backend.MENU_SERVICE;
    const appNavigator = isSupportAdminRoute ? undefined : (
        <IframeResizer title='RIO application menu' className='iFrameResizer' src={menuUrl} allowedOrigins='any' />
    );
    const homeRoute = isSupportAdminRoute ? config.helpGangHomeRoute : config.homeRoute;
    const chat = <OrderChat tenant={tenant} />;
    const notifications = <RioNotifications />;

    const actionBarItems = isSupportAdminRoute ? [userMenuItem] : [serviceInfo(), chat, notifications, userMenuItem];

    return (
        <ApplicationHeader
            appNavigator={appNavigator}
            label={config.applicationName}
            navItems={navItems}
            actionBarItems={actionBarItems}
            homeRoute={<a href={homeRoute} />}
        />
    );
};

export default AppHeader;
